const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '补遗澄清',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]
// const { getProjectTypeName } = require('../projectType')
const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    computed: {
        waitsData() {
            return this.$store.state.bids.waitIdsInfo
        },
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/file/change/zbFileChangeInfo`, { bdGuid: this.form.bdGuid }).then((res) => {
                this.config[1].options.data = {
                    '公告名称': res.data.ggName,
                    '项目名称': res.data.projectName,
                    '标段/包名称': res.data.bdName,
                    '标段/包编号': res.data.bdBH,
                    '变更标题': res.data.bgTitle,
                    '变更补遗类型': res.data.bgTypeC,
                }
                this.config[3].options.data = {
                    '获取开始时间': this.$util.timeFormatter(res.data.huoQuStartTime),
                    '获取结束时间': this.$util.timeFormatter(res.data.huoQuEndTime),
                    '澄清截止时间': this.$util.timeFormatter(res.data.daYiEndTime),
                    '截标/开标时间': this.$util.timeFormatter(res.data.kbTime),
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
